import request from 'axios';
import moment from 'moment';
import idx from 'idx';
import pick from 'lodash/pick';
import {
  EMAILS_RESOURCE_NAME, SINGLE_EMAIL_FORM_NAME, ATTRIBUTE_ENTRY_CONDITIONS
} from 'email_automations/constants';
import { DATETIME_FORMAT } from 'common/utils';
import { getAPIQueryString } from 'common/utils';
import { savePageCount } from 'common/pager/ducks';
import { showBanner, TYPE_SUCCESS } from 'common/ducks/banner';
import { setBannerError } from 'error';
import { sendTestEmail as sendTestEmailCommon } from 'email_automations/ducks/common';

/* ACTIONS
================================================================================================ */
const FETCH_TOTALS = 'crowdspring/honeybee/FETCH_TOTALS';
const FETCH_TOTALS_SUCCESS = 'crowdspring/honeybee/FETCH_TOTALS_SUCCESS';

const FETCH_EMAILS = 'crowdspring/honeybee/FETCH_EMAILS';
const FETCH_EMAILS_REQUEST = 'crowdspring/honeybee/FETCH_EMAILS_REQUEST';
const FETCH_EMAILS_SUCCESS = 'crowdspring/honeybee/FETCH_EMAILS_SUCCESS';

const FETCH_EMAIL = 'crowdspring/honeybee/FETCH_EMAIL';
const FETCH_EMAIL_REQUEST = 'crowdspring/honeybee/FETCH_EMAIL_REQUEST';
const FETCH_EMAIL_SUCCESS = 'crowdspring/honeybee/FETCH_EMAIL_SUCCESS';

const SEND_EMAIL = 'crowdspring/honeybee/SEND_EMAIL';
const SEND_EMAIL_SUCCESS = 'crowdspring/honeybee/SEND_EMAIL_SUCCESS';

const SAVE_EMAIL = 'crowdspring/honeybee/SAVE_EMAIL';

/* HELPERS
================================================================================================ */
// TODOexport const createEmailRequest = () => request.post(`/api/v1/single-emails/`);
export const createEmailRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve({ data: {
        id: 10, name: 'Email 10', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8 }});
  }, 1000);
});


//TODOexport const cloneEmailRequest = (id) => request.post(`/api/v1/single-emails/${id}/clone/`);
export const cloneEmailRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve({ data: {
        id: 10, name: 'Email 10', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8 }});
  }, 1000);
});

//TODOexport const deleteEmailRequest = (id) => request.delete(`/api/v1/single-emails/${id}/`);
export const deleteEmailRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve();
  }, 1000);
});



/* INITIAL STATES
================================================================================================ */
const initialState = {
  totals: {},
  emails: [],
  emailCount: 0,
  isFetching: false,
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOTALS_SUCCESS:
      return {
        ...state,
        totals: action.payload
      };
    case FETCH_EMAIL_REQUEST:
    case FETCH_EMAILS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_EMAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        emails: action.payload.results,
        emailCount: action.payload.count
      };
    case FETCH_EMAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        email: {
          ...action.payload,
          name: action.payload.name || "Untitled email"
        }
      };
    case SEND_EMAIL_SUCCESS:
      return {
        ...state,
        email: action.payload
      };
    default:
      return state;
  }
}

export const fetchTotals = () => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: FETCH_TOTALS_SUCCESS, payload: {
    draft: 5, sent: 6, scheduled: 10
  } }), 1000);

  return dispatch({
    type: FETCH_TOTALS,
    promise: request.get('/api/v1/single-emails/totals/'),
  });
};

export const fetchEmails = (query, status) => (dispatch) => {
  const extraAPIQuery = status === "all"? {} : { status };
  const queryStr = getAPIQueryString(EMAILS_RESOURCE_NAME, query, { extraAPIQuery });
  //TODOconst promise = request.get(`/api/v1/single-emails/?${queryStr}`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {
        count: 31,
        limit: 24,
        results: [
          { id: 1, name: 'Email 1', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8, count_targeted_total: 1000 },
          { id: 2, name: 'Email 2', status: "sent", last_action: 'edit', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 500, count_delivered_total: 200, count_unique_confirmed_opened_total: 500, count_unique_clicked_total: 66, count_unsubscribe_total: 78, count_spam_complaint_total: 89, count_targeted_total: 1000 },
          { id: 3, name: 'Email 3', status: "scheduled", last_action: 'schedule', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 1500, count_delivered_total: 1200, count_unique_confirmed_opened_total: 500, count_unique_clicked_total: 660, count_unsubscribe_total: 788, count_spam_complaint_total: 899, count_targeted_total: 1000 },
          { id: 4, name: 'Email 4', status: "draft", last_action: 'send', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 1500, count_delivered_total: 1200, count_unique_confirmed_opened_total: 500, count_unique_clicked_total: 660, count_unsubscribe_total: 788, count_spam_complaint_total: 899, count_targeted_total: 1000, html_design: {"counters":{"u_column":1,"u_row":1,"u_content_text":1},"body":{"rows":[{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"deletable":true,"color":"#000","textAlign":"left","lineHeight":"140%","text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">This is a new Text block. Chhange the text.</span></p>"}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideMobile":false,"noStackMobile":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"deletable":true}}],"values":{"backgroundColor":"red","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}}} },
        ]
      }});
    }, 1000);
  });

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(EMAILS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_EMAILS,
    promise
  });
};

export const fetchEmail = (id) => (dispatch) => {
  /*TODOconst promise = request.get(`/api/v1/single-emails/${id}/`);*/
  /*TODOconst promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {
           id: parseInt(id), name: 'Email 1', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8, recipient_emails: [], extra_link_attributes: {utm_source: 'source', utm_medium: 'medium', utm_name: 'name'}, recipient_selection_condition_context: {marketing_segment: 'agency', n_projects: 10}, preheader: 'preheader', subject: 'Subject', 'from_email': '', from_name: 'CS', text_content: 'blablebli', recipient_selection_condition: 'active_clients_that_posted_n_projects_or_more', scheduled_for: '2019-09-28T17:10:24Z', html_design: {"counters":{"u_column":1,"u_row":1,"u_content_text":1},"body":{"rows":[{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"deletable":true,"color":"#000","textAlign":"left","lineHeight":"140%","text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">This is a new Text block. Chhange the text.</span></p>"}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideMobile":false,"noStackMobile":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"deletable":true}}],"values":{"backgroundColor":"red","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}}}  }});
    }, 1000);
  }); */
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {
           id: parseInt(id), status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8, recipient_emails: [], extra_link_attributes: {}, recipient_selection_condition_context: {}, html_design: {}}});
    }, 1000);
  });


  return dispatch({
    type: FETCH_EMAIL,
    promise
  });
};

export const sendEmail = (id) => (dispatch) => {
  //TODOconst promise = request.post(`/api/v1/single-emails/${id}/send/`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {
           id: parseInt(id), name: 'Email 1', status: "sent", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8, recipient_emails: [], extra_link_attributes: {utm_source: 'source', utm_medium: 'medium', utm_name: 'name'}, recipient_selection_condition_context: {marketing_segment: 'agency', n_projects: 10}, preheader: 'preheader', subject: 'Subject', 'from_email': '', from_name: 'CS', text_content: 'blablebli', recipient_selection_condition: 'active_clients_that_posted_n_projects_or_more', scheduled_for: '2019-09-28T17:10:24Z', html_design: {"counters":{"u_column":1,"u_row":1,"u_content_text":1},"body":{"rows":[{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"deletable":true,"color":"#000","textAlign":"left","lineHeight":"140%","text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">This is a new Text block. Chhange the text.</span></p>"}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideMobile":false,"noStackMobile":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"deletable":true}}],"values":{"backgroundColor":"red","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}}}  }});
    }, 1000);
  });

  promise.catch((err) => {
    const errorMsg = idx(err, _ => _.data.message) || 'Unknown error';
    dispatch(setBannerError('Error sending single email', errorMsg));
  });

  dispatch({
    type: SEND_EMAIL,
    promise
  });

  return promise;
};

export const saveEmail = (id) => (dispatch, getState) => {
  const formData = getState().form[SINGLE_EMAIL_FORM_NAME].values || {};

  let recipientEmails = [];
  if (formData.recipients === "list" && formData.recipient_emails) {
    recipientEmails = formData.recipient_emails.split('\n');
  }

  let selectionContext = {};
  if (formData.recipients === "condition" && formData.attribute_condition) {
    const condition = ATTRIBUTE_ENTRY_CONDITIONS.find(
      c => c.field === formData.attribute_condition
    );
    const extraContextKeys = (condition.extraContext || []).map(f => f.name);
    selectionContext = pick(formData, ...extraContextKeys);
  }

  let scheduledFor;
  if (
    formData.time === 'specific_datetime' &&
    moment(formData.scheduled_for, DATETIME_FORMAT).isValid()
  ) {
    scheduledFor = moment(formData.scheduled_for, DATETIME_FORMAT).format();
  }

  const data = {
    ...pick(formData, 'name', 'preheader', 'subject', 'from_email', 'from_name', 'text_content'),
    extra_link_attributes: pick(formData, 'utm_source', 'utm_medium', 'utm_name'),
    recipient_emails: recipientEmails,
    recipient_selection_condition: (
      formData.recipients === "condition"? formData.attribute_condition : ''
    ),
    recipient_selection_condition_context: selectionContext,
    scheduled_for: scheduledFor,
    html_content: idx(formData, _ => _.html_data.html) || '',
    html_design: idx(formData, _ => _.html_data.design) || ''
  };

  //TODOconst promise = request.patch(`/api/v1/single-emails/${id}/`, data);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {}});
    }, 1000);
  });

  promise.then(() => {
    dispatch(showBanner('Success', 'Single email successfully saved.', undefined, TYPE_SUCCESS));
  }).catch((err) => {
    const errorMsg = idx(err, _ => _.data.message) || 'Make sure the data you entered is correct.';
    dispatch(setBannerError('Error saving single email', errorMsg));
  });

  return dispatch({
    type: SAVE_EMAIL,
    promise
  });
};

export const sendTestEmail = (_, { emails }) => (dispatch, getState) => {
  const formData = getState().form[SINGLE_EMAIL_FORM_NAME].values || {};
  return dispatch(sendTestEmailCommon(formData, emails));
}



// WEBPACK FOOTER //
// ./email_automations/ducks/honeybee.js